import script from "./product-variant.vue?vue&type=script&setup=true&lang=js"
export * from "./product-variant.vue?vue&type=script&setup=true&lang=js"

import "./product-variant.vue?vue&type=style&index=0&id=de792292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de792292"]])

export default __exports__